<!-- <app-line-loader *ngIf="loading" [sseConfig]="sseConfig"></app-line-loader> -->
<ng-container>
  <div
    class="mt-4 border border-gray-200 rounded-xl p-3 flex flex-row"
    *ngIf="
      !noData &&
      (fields?.displayName == 'Departments' ||
        fields?.displayName == 'Locations' ||
        fields?.displayName == 'Users')
    "
  >
    <img
      src="./assets/media/data-view/users.png"
      *ngIf="fields?.displayName == 'Users'"
      class="mt-2 h-12 w-12"
    />
    <img
      src="./assets/media/data-view/locations.png"
      *ngIf="fields?.displayName == 'Locations'"
      class="mt-2 h-12 w-12"
    />
    <img
      src="./assets/media/data-view/departments.png"
      *ngIf="fields?.displayName == 'Departments'"
      class="mt-2 h-12 w-12"
    />

    <div class="flex-col ms-3">
      <span class="text-md font-semibold mb-3 block text-gray-900">
        {{ fieldsData?.totalCount }}
        <span class="ms-1">{{ fields?.displayName }}</span>
      </span>

      <div
        class="flex items-center relative"
        *ngIf="fields?.displayName == 'Users'"
      >
        <ng-container
          *ngFor="let option of fieldsData?.records.slice(0, 7); let i = index"
        >
          <div
            [ngClass]="getBgColorByDepartment(option.name)"
            class="w-10 h-10 rounded-full text-white text-sm font-bold uppercase border-2 border-white"
            [ngStyle]="{
              'margin-left': i !== 0 ? '-12px' : '0px',
              'z-index': 100 - i,
            }"
          >
            <div class="w-full h-full flex items-center justify-center">
              {{ getInitials(option.name) }}
            </div>
          </div>
        </ng-container>

        <div
          *ngIf="fieldsData?.records.length > 7"
          class="w-10 h-10 rounded-full bg-gray-800 text-white text-xs font-semibold border-2 border-white -ml-3"
          style="z-index: 0; margin-left: -12px"
        >
          <div class="w-full h-full flex items-center justify-center">
            +{{ fieldsData.records.length - 7 }}
          </div>
        </div>
      </div>

      <ng-container *ngIf="fields?.displayName == 'Departments'">
        <div class="flex flex-row flex-wrap gap-2">
          <span
            *ngFor="let option of fieldsData?.records"
            class="badge-light-info h-30px badge badge-md badge-outline rounded-md text-xs text-gray-600"
          >
            {{ option.name }}
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="fields?.displayName == 'Locations'">
        <div
          class="flex items-center flex-row"
          *ngFor="let option of fieldsData?.records"
        >
          <span class="text-xs text-gray-600">{{ option.name }}</span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- ✅ Updated grid section -->
  <ng-container
    *ngIf="
      !noData &&
      fields?.displayName != 'Departments' &&
      fields?.displayName != 'Locations' &&
      fields?.displayName != 'Users'
    "
  >
    <div class="flex justify-center graph-card">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 w-full max-w-6xl"
      >
        <ng-container *ngFor="let option of fieldsData?.records">
          <div
            class="border border-gray-200 rounded-xl p-3 flex flex-row items-start hover:bg-secondary-active transition-shadow"
            *ngIf="
              !noData &&
              fields?.displayName != 'Departments' &&
              fields?.displayName != 'Locations' &&
              fields?.displayName != 'Users'
            "
          >
            <img [src]="getAssetIcon(option.name)" class="mt-2 h-12 w-12" />
            <div class="flex-col ms-3 flex-1 min-w-0">
              <span
                class="text-sm font-semibold text-gray-900 block line-clamp-2 break-all"
                [title]="option.name"
              >
                {{ option.name }}
              </span>
              <span
                class="text-xs text-gray-600 block line-clamp-2 break-all"
                [title]="'Total ' + option?.itemcount + ' ' + option.name"
              >
                Total {{ option?.itemcount }} {{ option.name }}
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <div
    class="mt-4 border border-gray-200 rounded-xl p-3 flex flex-row items-center bg-gray-50/20 dark:bg-coal-800/10"
    *ngIf="
      noData &&
      (fields?.displayName == 'Departments' ||
        fields?.displayName == 'Locations' ||
        fields?.displayName == 'Users')
    "
  >
    <img
      src="./assets/media/data-view/users.png"
      *ngIf="fields?.displayName == 'Users'"
      class="h-12 w-12 grayscale opacity-40 flex-shrink-0"
    />
    <img
      src="./assets/media/data-view/locations.png"
      *ngIf="fields?.displayName == 'Locations'"
      class="h-12 w-12 grayscale opacity-40 flex-shrink-0"
    />
    <img
      src="./assets/media/data-view/departments.png"
      *ngIf="fields?.displayName == 'Departments'"
      class="h-12 w-12 grayscale opacity-40 flex-shrink-0"
    />

    <div class="flex flex-col ms-3 text-start">
      <span class="text-sm font-semibold text-gray-500 block">
        0 {{ fields?.displayName }}
      </span>
      <span class="text-xs text-gray-400 block mt-0.5">
        No data synced for this category
      </span>
    </div>
  </div>

  <div
    class="flex flex-col items-center justify-center text-center p-6 border border-dashed border-gray-200 rounded-xl bg-gray-50/20 dark:bg-coal-800/10 mt-4 w-full"
    *ngIf="
      noData &&
      fields?.displayName != 'Departments' &&
      fields?.displayName != 'Locations' &&
      fields?.displayName != 'Users'
    "
  >
    <div
      class="w-10 h-10 rounded-full bg-gray-100 dark:bg-coal-800 flex items-center justify-center mb-3"
    >
      <i
        class="ki-outline ki-folder-error text-xl text-gray-400 dark:text-gray-500"
      ></i>
    </div>
    <span class="text-sm font-semibold text-gray-900 dark:text-white">
      No {{ fields?.displayName || "Data" }} Available
    </span>
    <span
      class="text-xs text-gray-500 dark:text-gray-400 mt-1 max-w-[240px] leading-relaxed"
    >
      There is no {{ (fields?.displayName || "data")?.toLowerCase() }} to
      display yet
    </span>
  </div>
</ng-container>
